module.exports = __webpack_public_path__ + "purple1.c2fb185a.png";